import React, { Component } from 'react';
import moment from 'moment-with-locales-es6';
import { Modal } from "react-bootstrap"
import Sidebar from './Sidebar';
import { connect} from "remx";
import broker from '../../utils/broker';

import dataStore from '../../stores/data';
import TableTraffic from './Contents/TableTraffic';
import LiveGraphic from './Contents/LiveGraphic';
import DataMap from './Contents/DataMap';
import ContentHeaderDate from './ContentHeaderDate';
import TableTrouble from './Contents/TableTrouble';
import Resume from './Contents/Resume';
import ContentHeaderDateAdd from './ContentHeaderDateAdd';

class DataTraffic extends Component {
    constructor(props) {
        super(props);
    
    this.options = {

    }

    this.state = {
            reload:false,
            loading: false,
            id_pk_column: 'id',
            data_pelanggan : {},
            drag_marker : false,
            hour_traffic : "0",
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.addTraffic = this.addTraffic.bind(this);
    }

    getDataPelanggan(){
        broker.fetch.get(`pelanggan/${this.props.pelanggan_id}`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                this.setState({data_pelanggan : data.data})
                dataStore.setters.setDataPelanggan(data.data);
            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        var addScript = document.createElement('script');
        addScript.setAttribute('src', '/assets/js/dashforge.contacts.js');
        document.body.appendChild(addScript);
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log(this.state.data_pelanggan)
        if(this.props.pelanggan_id !== prevProps.pelanggan_id){
            if(this.props.pelanggan_id !== ""){
                this.getDataPelanggan(); 
            } else {
                // this.setState({data_pelanggan : {}});
            }
        }

    }

    generateContent(){
        var content = this.props.data_pelanggan;
        // console.log(content)
        let return_content = [];
        if (content) {
            for (var key in content){
                if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                    return_content.push(<React.Fragment key={key}>
                                            <label className="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase" key={key}>{key.replace("_", " ")}</label>
                                            <p className="tx-13 mg-b-10">{content[key]}</p>
                                        </React.Fragment>);
    
            }
        }

        return return_content;
    }

    setDragMarker(){
        if (this.state.drag_marker === true){
            this.setState({ drag_marker: false }, function(){
                this.getDataPelanggan();
            })
            
        } else {
            this.setState({ drag_marker: true })
        }
        
    }

    handleSelect(e){
        this.setState({
            hour_traffic : e.target.value
        })
    }

    addTraffic() {
        let body = {
            pelanggan_id : this.props.pelanggan_id,
            hour : this.state.hour_traffic,
            day : moment(this.props.date_view).locale('id').format('DD'),
            month :  moment(this.props.date_view).locale('id').format('MM'),
            year :  moment(this.props.date_view).locale('id').format('YYYY')
        }

        broker.fetch.post(`/tr_bandwidth`, body)
        .then(res => {
            const { data } = res.data;
            if (data) {
                dataStore.setters.setReloadTable(true);
                dataStore.setters.setModalTraffic(false)
            } else {

            }
        }).catch(err => {
            dataStore.setters.setModalTraffic(false)
            
        });

    }

    render(){
        return(
            <div className="contact-wrapper">
                <Sidebar />
                <div className="contact-content">
                    <div className="chat-content-header">
                        {(this.props.form_view == 'data_traffic' || this.props.form_view === 'live_graphic' ) &&
                            <ContentHeaderDateAdd />
                        }
                        {(this.props.form_view === 'data_down') &&
                            <ContentHeaderDate />
                        } 
                        {(this.props.form_view === 'map_pekerjaan') &&
                            <React.Fragment>
                                <div>
                                    <h6 id="channelTitle" className="mg-b-0">#MapPelanggan</h6>
                                </div>
                                
                                {(this.props.pelanggan_id) &&
                                   <React.Fragment>
                                        <div>
                                            <h6 className="mg-b-0 tx-spacing-1 mg-r-30">Latitude : {this.props.lat_lng.lat}, Longitude : {this.props.lat_lng.lng}</h6>
                                        </div>
                                        <div className="d-none d-md-block  mg-r-300">
                                            <button type="button" className="btn btn-sm btn-white" onClick={()=>this.setDragMarker()}>
                                            <i className={"mg-r-5 " + (this.state.drag_marker ? "far fa-bookmark" : "fas fa-edit ")}></i>
                                            {(this.state.drag_marker) ? 'Simpan' : 'Update'}
                                            </button>
                                        </div>
                                   </React.Fragment>
                                }

                            </React.Fragment>
                        }
                        {(this.props.form_view === 'resume') &&
                            <React.Fragment>
                                <div>
                                    <h6 id="channelTitle" className="mg-b-0">#ResumePelanggan</h6>
                                </div>
                            </React.Fragment>
                        }
                        
                    </div>
                    <div className="contact-content-body mg-t-5" style={{backgroundColor: 'white'}}>
                        {(this.props.form_view === 'resume') &&
                            <Resume />
                        }
                        {(this.props.form_view === 'data_traffic') &&
                            <TableTraffic />
                        }
                        {(this.props.form_view === 'live_graphic') &&
                            <LiveGraphic />
                        }
                        {(this.props.form_view === 'data_down') &&
                            <TableTrouble />
                        }
                        {(this.props.form_view === 'map_pekerjaan') &&
                            <DataMap draggable={this.state.drag_marker}/>
                        }
                    </div>
                    <div className="contact-content-sidebar">
                        <label className="nav-label tx-color-03">Detail Data</label>
                        <hr className="mg-t-5"></hr>
                        {(this.state.data_pelanggan) &&
                            this.generateContent()
                        }
                    </div>
                </div>
                <Modal show={this.props.modal_add_traffic} onHide={() => dataStore.setters.setModalTraffic(false)} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Manual Traffic</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">MRTG Hour</label>
                            <div className="col-sm-9">
                                <select className="custom-select"                                
                                        value={this.state.hour_traffic}
                                        id="hour_traffic"
                                        name="hourTraffic"
                                        onChange={this.handleSelect}
                                >
                                    <option value="0">00.00</option>
                                    <option value="1">01.00</option>
                                    <option value="2">02.00</option>
                                    <option value="3">03.00</option>
                                    <option value="4">04.00</option>
                                    <option value="5">05.00</option>
                                    <option value="6">06.00</option>
                                    <option value="7">07.00</option>
                                    <option value="8">08.00</option>
                                    <option value="9">09.00</option>
                                    <option value="10">10.00</option>
                                    <option value="11">11.00</option>
                                    <option value="12">12.00</option>
                                    <option value="13">13.00</option>
                                    <option value="14">14.00</option>
                                    <option value="15">15.00</option>
                                    <option value="16">16.00</option>
                                    <option value="17">17.00</option>
                                    <option value="18">18.00</option>
                                    <option value="19">19.00</option>
                                    <option value="20">20.00</option>
                                    <option value="21">21.00</option>
                                    <option value="22">22.00</option>
                                    <option value="23">23.00</option>
                                </select>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-danger" type="button" onClick={() => dataStore.setters.setModalTraffic(false)}>Close</button>
                        <button className="btn btn-primary" type="button" onClick={() => this.addTraffic()}>Save Traffic</button>
                    </Modal.Footer>
                </Modal>  
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
        form_view : dataStore.getters.getDataFormView(),
        lat_lng : dataStore.getters.getLatLon(),
        data_pelanggan : dataStore.getters.getDataPelanggan(),
        modal_add_traffic : dataStore.getters.getModalTraffic()
    }
}


export default connect(mapStateToProps)(DataTraffic);